module.exports = __webpack_public_path__ + "static/media/overpass-mono-light.3be32ac5.ttf";